<template>
  <header
    class="d-flex flex-column justify-content-center w-100 text-center pb-4"
  >
    <img
      src="/assets/img/game_resources/header.jpg"
      alt="Torn: Legendary Battles"
      class="header-img"
    />

    <section class="container pb-0">
      <div class="row">
        <router-link
          v-for="link in links"
          :key="link.url"
          :to="link.url"
          exact-active-class="active-link"
          class="col-xs-12 col-md-3 header-link"
        >
          {{ link.text }}
        </router-link>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  name: 'app-header',

  data: () => ({
    links: [
      { url: '/', text: 'Início' },
      { url: '/rules', text: 'Regras' },
      { url: '/races', text: 'Raças' },
      { url: '/classes', text: 'Classes' },
      { url: '/battlefield', text: 'Campo de Batalha' },
      { url: '/effects', text: 'Lista de Efeitos' },
      { url: '/modes', text: 'Modos de Jogo' },
      { url: '/generator', text: 'Gerador de Campo e Personagens' }
    ]
  })
}
</script>

<style lang="sass" scoped>
.header-img
  width: 100%
  margin-bottom: 10px

.active-link
  background-color: #222

.header-link
  padding: 5px 0
  border-radius: 5px
  cursor: pointer
  text-align: center
  text-transform: uppercase
</style>
